/**
 * Design Tokens: Index
 *
 * Este arquivo exporta todos os tokens de design em um único ponto de acesso.
 * Segue o princípio do Atomic Design para a organização de tokens fundamentais.
 */

import colors, { gradients, gradientColors } from './colors';
import operationalTokens, {
  operationalElevation,
  operationalComponentSurfaces,
  operationalBrandColors,
  operationalFeedback,
  operationalFontSizes,
  operationalModal,
  operationalMotion,
  operationalRadii,
  operationalScrollbars,
  operationalSizing,
  operationalSnackbar,
  operationalSpacing,
  operationalSurfaces,
  operationalStatusColors,
  operationalText,
  operationalToolbars,
  operationalTypography,
  getOperationalMode,
  getOperationalText,
  getSelectionToolbarTokens,
} from './operational';
import shadows from './shadows';
import shapes from './shapes';
import typography from './typography';

export {
  colors,
  gradients,
  gradientColors,
  getOperationalMode,
  getOperationalText,
  getSelectionToolbarTokens,
  operationalElevation,
  operationalComponentSurfaces,
  operationalBrandColors,
  operationalFeedback,
  operationalFontSizes,
  operationalModal,
  operationalMotion,
  operationalRadii,
  operationalScrollbars,
  operationalSizing,
  operationalSnackbar,
  operationalSpacing,
  operationalSurfaces,
  operationalStatusColors,
  operationalText,
  operationalToolbars,
  operationalTokens,
  operationalTypography,
  shadows,
  shapes,
  typography
};

const tokens = {
  colors,
  gradients,
  gradientColors,
  operational: operationalTokens,
  shadows,
  shapes,
  typography
};

export default tokens;
